var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dynamic-collection-tabs" },
    [
      _c("dynamic-tabs-nav", {
        attrs: {
          label: _vm.navLabel,
          links: _vm.collectionLinks,
          "active-link": _vm.activeCollectionHandle
        },
        on: { click: _vm.changeCollection, select: _vm.changeCollection }
      }),
      _vm._v(" "),
      _vm.activeCollection
        ? _c("div", { staticClass: "dynamic-collection-tabs-content" }, [
            _c(
              "div",
              { staticClass: "dynamic-collection-tabs-content-inner" },
              [
                _c(
                  "ul",
                  { staticClass: "dynamic-collection-tabs-content-grid" },
                  _vm._l(_vm.activeCollection.products, function(product) {
                    return _c("product-grid-item", {
                      key: product.id,
                      attrs: {
                        "image-src": product.imageSrc,
                        price: product.price,
                        tags: product.tags,
                        title: product.title,
                        url: product.url,
                        available: product.available,
                        "sold-out-label": _vm.soldOutLabel
                      }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("footer", [
                  _c(
                    "a",
                    {
                      staticClass: "dynamic-collection-tabs-content-cta",
                      attrs: { href: _vm.activeCollection.url }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.shopThisCollectionLabel) +
                          "\n\n          "
                      ),
                      _c(
                        "svg",
                        { staticClass: "pxl-icon pxl-icon-chevron-right" },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#pxl-icon-chevron-right" }
                          })
                        ]
                      )
                    ]
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }